export default __webpack_public_path__ + "static/media/untitled-design.7d283d45.svg";